<template>
  <div :class="['result__item', result.isFeatured && 'result__item--featured'] ">
    <span class="result__item-badge " v-if="result.isFeatured">
      <span>پیشنهاد ویژه</span>
    </span>
    <div class="result__item-image">
      <div class="result__item-duration fa-num" v-if="result.accommodationNight">
        {{ result.accommodationNight }} <span>{{ "شب" }}</span>
      </div>
      <picture>
        <source
          :data-srcset="`${getImagePrefixAddress}${result.coverUrl}`"
        />

        <img
          class="lazyload"
          src="/Themes/SoofiGashtV2/UI/Dist/images/default-image.svg"
          :alt="result.title"
        />
      </picture>
    </div>

    <div class="result__item-info">
      <div class="result__item-info-header">
        <h3 class="result__item-header-title">
          {{ result.title }}
          <button
          @click="toggleFavorite(result.tourId)"
          ref="favoriteBtn"
          class="tour-card__bookmark  btn--bookmark hide-in-desktop" 
        >
          <i class="icon-bookmark"></i>
        </button>
        </h3>
        <ul class="result__item-header-detail">
          <li v-if="result.serializedCity">
            <i class="icon-pin" />

            <span>
              {{ result.serializedCity.split(",").join("، ") }}
            </span>
          </li>

          <li v-if="!result.tourCapacity || !result.minChildArrivalDate">

            <span
              v-if="result.state === 16"
              class="result__full-capacity"
            >
              <i class="icon-user" />
              ظرفیت تکمیل.
            </span>
          </li>
        </ul>
        <ul class="result__item-sub-header-detail">
          <li v-if="result.childInfo.length" class="fa-num">
            <i class="icon-calendar-fill" />
            {{ occurDate }}
          </li>
          <li v-if="result.airLineTitle" >
            <i class="icon-airplane" />

            {{ result.airLineTitle.split(",").join("، ") }}
          </li>

          <li v-if="result.durationAccommodation" >
            <i class="icon-bed" />

            <span class="fa-num text-truncate">
              {{ result.hotel }}
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div class="result__item-bookmark hide-in-not-desktop">
      <button
        @click="toggleFavorite(result.tourId)"
        ref="favoriteBtn"
        class="tour-card__bookmark  btn--bookmark" 
      >
        <i class="icon-bookmark"></i>
      </button>
    </div>
    <div class="result__item-price">
      <div>
        <span class="result__item-price-title">قیمت از</span>
        <ul
          class="result__item-price-items"
          v-if="result.minimumPrices && result.minimumPrices.length"
        >
          <li
            class="result__item-price-item"
            v-for="(price, index) in result.minimumPrices"
            :key="index"
          >
            <span class="fa-num">{{ formatPrice(price.price) }}</span>
            <label>{{ price.currencyTitle }}</label>
          </li>
        </ul>

        <span class="result__item-price-unknown" v-else>مشخص نیست‌</span>
      </div>
      <a :href="'/tour/' + result.slug" :title="result.title" class="btn btn--secondary">
       رزرو تور
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment-jalaali";

export default {
  name: "ResultItem",

  props: {
    result: {
      type: Object,
    },
  },

  data() {
    return {
      occurDate: "",
      firstRunDate: "",
      endRunDate: "",
    };
  },

  computed: {
    ...mapGetters([
      "getImagePrefixAddress",
      "getAddFavoriteUrl",
      "getFavoritePrefix",
      "getIsUserAuthenticated",
    ]),
  },

  methods: {
    ...mapActions(["addToFavorite", "showAlert"]),
    // toggle tour favorite
   
    toggleFavorite(tourId) {
      if (this.getIsUserAuthenticated) {
        this.addToFavorite({
          element: this.$refs.favoriteBtn,
          entityType: 1001,
          entityRef: tourId,
          url: this.getFavoritePrefix,
        });
      } else {
        this.showAlert({
          messages: [ 
            {
              message: "برای دسترسی به این قسمت باید وارد سایت شوید",
              type: 2,
            },
          ],
        });
      }
    },

    // return persian date
    persianDate(date, format = "jDD jMMMM ") {
      moment.loadPersian({
        dialect: "persian-modern",
      });
      return date ? moment(date).format(format) : "";
    },

    // format price
    formatPrice(price) {
      if (price) {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return "";
      }
    },

    // return tour end run
    calcEndRunDate() {
      let endRunDate = "";

      if (this.result.childInfo && this.result.childInfo.length) {
        const firstChildInfo = this.result.childInfo.sort((a, b) => {
          return new Date(a.departureDate) - new Date(b.departureDate);
        });

        if (firstChildInfo.length > 0) {
          endRunDate = firstChildInfo[0].departureDate;
        }
      }

      return endRunDate;
    },
    calculateOccurMonth() {
      const startMonth = this.persianDate(this.firstRunDate, " jMMMM ");
      const endMonth = this.persianDate(this.endRunDate, " jMMMM ");
      const createMonth =
        startMonth === endMonth ? startMonth : `${startMonth}و${endMonth}`;
      const createYear = ` ${this.persianDate(this.firstRunDate, "jYYYY")}`;
      return createMonth + createYear;
    },
    // return tour first run
    calcFirstRunDate() {
      let firtRunDate = "";

      if (this.result.childInfo && this.result.childInfo.length) {
        const firstChildInfo = this.result.childInfo.sort((a, b) => {
          return new Date(a.arrivalDate) - new Date(b.arrivalDate);
        });

        if (firstChildInfo.length > 0) {
          firtRunDate = firstChildInfo[0].arrivalDate;
        }
      }

      firtRunDate = firtRunDate;

      return firtRunDate;
    },
  },

  created() {
    this.firstRunDate = this.calcFirstRunDate();
    this.endRunDate = this.calcEndRunDate();
    this.occurDate = this.calculateOccurMonth();
  },
};
</script>
<style lang="scss">
@import "../style/modules/_result.scss";
</style>
